import { buildUrl, contextAwareHeaders } from './apiClient';

const parseJson = async (response) => response.json().catch(() => ({}));

export const fetchNearbyDiscovery = async ({ latitude, longitude, radiusKm = 25, limit = 8, signal } = {}) => {
  const url = new URL(buildUrl('/api/discovery/nearby'));
  url.searchParams.set('latitude', String(latitude));
  url.searchParams.set('longitude', String(longitude));
  url.searchParams.set('radiusKm', String(radiusKm));
  url.searchParams.set('limit', String(limit));

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: contextAwareHeaders(),
    signal,
  });

  const data = await parseJson(response);

  if (!response.ok) {
    const error = new Error(data?.error || data?.message || 'Unable to load nearby discovery right now.');
    error.status = response.status;
    throw error;
  }

  return {
    liveMatches: Array.isArray(data?.liveMatches) ? data.liveMatches : [],
    upcomingMatches: Array.isArray(data?.upcomingMatches) ? data.upcomingMatches : [],
    ongoingTournaments: Array.isArray(data?.ongoingTournaments) ? data.ongoingTournaments : [],
    upcomingTournaments: Array.isArray(data?.upcomingTournaments) ? data.upcomingTournaments : [],
    radiusKm: Number(data?.radiusKm || radiusKm),
    latitude: Number(data?.latitude || latitude),
    longitude: Number(data?.longitude || longitude),
  };
};
